// SidebarContext.tsx

import { FC, useState, createContext } from 'react';

export type NetworkType = 'mainnet' | 'testnet';

type SidebarContextType = {
  sidebarToggle: boolean;
  toggleSidebar: () => void;
  closeSidebar: () => void;
  network: NetworkType;
  setNetwork: (network: NetworkType) => void;
};

export const SidebarContext = createContext<SidebarContextType>(
  {} as SidebarContextType
);

export const SidebarProvider: FC = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [network, setNetwork] = useState<NetworkType>('mainnet');

  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const closeSidebar = () => {
    setSidebarToggle(false);
  };

  return (
    <SidebarContext.Provider
      value={{ sidebarToggle, toggleSidebar, closeSidebar, network, setNetwork }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
